import { createSelector } from '@reduxjs/toolkit';
import { selectOptionsPercentTotal, selectOptionsPlusTotal, selectProjectsDetails } from '../project/projectSelectros';

export const selectWordpress = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.wordpress || {}
);

export const selectWordpressCalculationParams = createSelector(
  selectWordpress,
  projectOther => projectOther.calculationOptions || {}
);

export const selectWordpressPagesTotal = () => {
  return {
    discount: 0,
    totalPricePages: 0
  };
};

export const selectWordpressOptionsTotal = createSelector(
  selectWordpressPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectWordpressTotal = createSelector(
  selectWordpressPagesTotal,
  selectWordpressOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectWordpressTotalForAsap = createSelector(
    selectWordpressTotal,
    (totalPrice) => {
      return totalPrice / 2;
    }
);

export const selectWordpressEta = () => ({
  etaText: '',
  etaIsExists: false
});

export const selectWordpressDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});
